import * as React from "react";
import { ClinicTable } from "./ClinicTable";
import { PaginationNavigation, SortTableContext } from "soprasteria-ui-library";
import { useAuth } from "../../../../../App";
import { ClinicApi } from "../../../../../api/ClinicApi";
import { IClinicListItem, IClinicSearchParams } from "../../../../../models/IClinic";
import { useHistory } from 'react-router-dom';
import { ORGANISATION } from "../../../../../utils/RouteConstants";
import { ISearchType } from "../../../../../models/ISearchType";
import { IPagination, SortOrder } from "soprasteria-ui-library/dist/models/IPagination";

interface IProps {
    organisationId: number;
}

export const ClinicTab: React.FC<IProps> = ({ organisationId }) => {
    const auth = useAuth();
    const api = new ClinicApi(auth);
    const pageSize = 10;
    const [paginationHeader, setPaginationHeader] = React.useState<IPagination>();
    const [clinics, setClinics] = React.useState<IClinicListItem[]>([]);
    const [searchParams, setSearchParams] = React.useState<IClinicSearchParams>();
    const { sortOrder, selectedPropertyToSortBy, setSelectedPropertyToSortBy, setSortOrder } = React.useContext(SortTableContext);
    const history = useHistory();
    const defaultOrderBy = "ClinicNumber";
    const abortController = new AbortController();

    React.useEffect(() => {
        if (setSelectedPropertyToSortBy && setSortOrder) {
            if (history.location.state !== undefined && history.location.state !== null) {
                const lastSearchParams = history.location.state as IClinicSearchParams;
                if (lastSearchParams.organisationId === organisationId && lastSearchParams.searchType === ISearchType.Clinic) {
                    getClinics(lastSearchParams);
                } else {
                    setSelectedPropertyToSortBy(defaultOrderBy);
                    setSortOrder(SortOrder.ascending);
                    getClinics({ searchType: ISearchType.Clinic, organisationId: organisationId, pageSize: pageSize, pageNumber: 1, propertyToOrderBy: defaultOrderBy, sortOrder: SortOrder.ascending });
                }

            } else {
                setSelectedPropertyToSortBy(defaultOrderBy);
                setSortOrder(SortOrder.ascending);
                getClinics({ searchType: ISearchType.Clinic, organisationId: organisationId, pageSize: pageSize, pageNumber: 1, propertyToOrderBy: defaultOrderBy, sortOrder: SortOrder.ascending });
            }
        }

        return () => {
            abortController.abort();
        }
    }, [organisationId])

    React.useEffect(() => {
        if (clinics) {
            onSortOrderClick();
        }
    }, [selectedPropertyToSortBy, sortOrder])

    const onSortOrderClick = () => {
        if (searchParams) {
            var currentSearchParams = searchParams;
            currentSearchParams.pageNumber = 1;
            currentSearchParams.sortOrder = sortOrder;
            currentSearchParams.propertyToOrderBy = selectedPropertyToSortBy;
            getClinics(currentSearchParams);

        }
    }

    const onPageSelect = (pageNumber: number) => {
        if (searchParams) {
            var newPageParams = searchParams;
            newPageParams.pageNumber = pageNumber;
            getClinics(newPageParams);
        }
    }

    const getClinics = (searchParams: IClinicSearchParams) => {
        history.replace(`/${ORGANISATION}/${organisationId}`, searchParams);
        api.getClinics(searchParams, (clinics) => {
            setClinics(clinics.data.clinics);
            setPaginationHeader(clinics.paginationHeader);
        }, undefined);

        setSearchParams(searchParams);
    };

    return (
        <section>
            <ClinicTable clinics={clinics} />
            <PaginationNavigation
                ariaLabel="clinic rows pagination selector"
                pagination={paginationHeader}
                pageNeighbours={2}
                selectedPage={page => onPageSelect(page)}
                showCount={true} />
        </section>
    )
}
